// client/src/search/synonyms.js
import { norm } from "./normalize";

// Gruppen sind bidirektional (bma <-> brandmeldeanlage etc.)
const BASE = {
  altersheim: ["seniorenheim", "pflegeheim", "heim", "alterszentrum", "seniorenzentrum"],
  seniorenheim: ["altersheim", "pflegeheim", "heim", "alterszentrum", "seniorenzentrum"],
  pflegeheim: ["altersheim", "seniorenheim", "heim", "pflegezentrum"],

  service: ["wartung","unterhalt","störung","stoerung","serviceauftrag","einsatz","reparatur","inspektion","kontrolle","wartungsauftrag"],
  maengel: ["mangel","mängel","defekt","mängelbericht","maengelbericht","fehler","schaden","beanstandung"],

  elektro: ["elektrik","elektriker","installation","elektroinstallation","elektrotechnik","strom","leitungsbau"],
  pv: ["photovoltaik","solaranlage","solar","pv-anlage","wechselrichter","strings","dc","ac"],
  sicherheit: ["alarm","alarmanlage","brand","brandmeldeanlage","bma","einbruchmeldeanlage","ema","videoueberwachung","videoüberwachung","cctv","zutritt","sirene","rauchmelder"],
  ladestation: ["wallbox","ev","ladepunkt","ladesaeule","ladesäule","chargepoint","eauto","e-mobility","emobility"],
  netzwerk: ["lan","wlan","wifi","netz","it","verkabelung","patchfeld","switch","router","access point","ap"],
  knx: ["bus","knx/eib","gebäudeautomation","gebaeudeautomation","smarthome","dali","aktor","sensor"],
  beleuchtung: ["licht","leuchten","lampen","notbeleuchtung","flutlicht"],
  sprechanlage: ["intercom","tuertelefon","türtelefon","gegensprechanlage","klingel","video-tuersprecher","video-türsprechanlage"],

  offerte: ["angebot","preisvorschlag","kostenangebot"],
  rechnung: ["invoice","abrechnung","rg","gutschrift","mahnung"],
  bestellung: ["order","auftrag","po","lieferschein","lieferung"],

  protokoll: ["messprotokoll","prüfprotokoll","pruefprotokoll","abnahmeprotokoll","inbetriebnahme","ibn-protokoll","testprotokoll"],
  plan: ["schema","schaltplan","verdrahtungsplan","grundriss","zeichnung","skizze"],
  dokument: ["datei","upload","anhang","pdf","foto","bild","scan"],

  kunde: ["kundin","auftraggeber","ag","mandant"],
  objekt: ["liegenschaft","gebäude","gebaeude","anlage","haus","wohnung","baustelle"],
  adresse: ["strasse","straße","hausnummer","plz","ort","gemeinde","stadt","kanton"],

  projekt: ["baustelle","objekt","auftrag","job","vorgang"],
  projektleiter: ["pl","projektleitung","verantwortlicher","owner"],
  mitarbeiter: ["monteur","elektriker","techniker","team","kollege"],
  lehrling: ["lernender","azubi","stift","apprentice"],

  material: ["artikel","komponente","gerät","geraet","teil","ersatzteil","kabel","leitung","rohr","kanal"],
  stunden: ["arbeitszeit","zeiten","arbeitsstunden","stundenrapport","rapport"],
  spesen: ["auslagen","kosten","reisekosten","spesenbeleg","quittung"],
  akonto: ["a-konto","teilzahlung","anzahlung","vorauszahlung"],
  kosten: ["summe","gesamtbetrag","preis","betrag","kalkulation"],

  // Häufige Elektro-Kürzel (damit du das NICHT überall per addSynonyms machen musst)
  uv: ["unterverteiler","verteiler","hauptverteilung","nshv","uv-verteilung"],
  hv: ["hauptverteilung","hauptverteiler"],
  ls: ["leitungsschutzschalter","automat","sicherung"],
  rcd: ["fi","fehlerschutzschalter","fehlerstrom"],
};

let SYN_VERSION = 0;
const SYN = new Map(); // term -> Set(terms)

function addGroup(terms) {
  const group = [...new Set((terms || []).map(norm).filter(Boolean))];
  if (group.length < 2) return;

  for (const t of group) {
    const set = SYN.get(t) || new Set();
    for (const u of group) if (u !== t) set.add(u);
    SYN.set(t, set);
  }
}

// Initial Build
for (const [k, arr] of Object.entries(BASE)) addGroup([k, ...(arr || [])]);

export function expandToken(t) {
  const key = norm(t);
  const out = new Set([key]);
  const set = SYN.get(key);
  if (set) for (const x of set) out.add(x);
  return [...out];
}

// Modul-/Projekt-spezifisch erweitern
export function addSynonyms(dict) {
  for (const [k, arr] of Object.entries(dict || {})) addGroup([k, ...(arr || [])]);
  SYN_VERSION++;
}

export function getSynonymsVersion() {
  return SYN_VERSION;
}

export function getAllSynonyms() {
  const obj = {};
  for (const [k, set] of SYN.entries()) obj[k] = [...set];
  return obj;
}
